import { Navigate, useParams } from "react-router-dom";
import { CITIES } from "@/components/site/seoData";
import { PageHero } from "@/components/site/PageHero";
import { CityLinks, ServiceLinks } from "@/components/site/SeoLinks";
import { HowItWorks } from "@/components/site/HowItWorks";
import { BeforeAfter } from "@/components/site/BeforeAfter";
import { Faq } from "@/components/site/Faq";
import { Quote } from "@/components/site/Quote";
import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";

export default function CityPage() {
  const { slug } = useParams();
  const c = CITIES.find((x) => x.slug === slug);
  if (!c) return <Navigate to="/" replace />;
  return (
    <>
      <Seo
        title={`Junk Removal ${c.name} SC | Cazares Junk Removal`}
        description={`Junk removal in ${c.name}, SC by Cazares Junk Removal. Furniture, appliances, hot tubs, yard waste and cleanouts. Free onsite quote and same-day pickup.`}
        path={`/junk-removal/${c.slug}`}
      />
      <PageHero eyebrow="Local junk removal company" title="Junk Removal" accent={`${c.name}, SC`} intro={c.intro} crumbs={["Service Area", `${c.name}, SC`]} />
      <section className="bg-[#F2EEE6] py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-4">
            <Eyebrow dark>Services in {c.name}</Eyebrow>
            <h2 className="font-display mt-4 text-5xl uppercase leading-[0.9] text-[#0D0D0B] sm:text-6xl">Junk hauling in {c.name}, SC</h2>
            <p className="mt-5 text-base text-[#3a3a35]">Residential and commercial junk removal for {c.name} homes, rentals and businesses. Pick a service to learn more.</p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-8"><ServiceLinks /></Reveal>
        </div>
      </section>
      <HowItWorks />
      <BeforeAfter />
      <section className="bg-[#0D0D0B] py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="font-display mb-6 text-4xl uppercase text-[#F2EEE6] sm:text-5xl">Also serving nearby</h2>
          <CityLinks exclude={c.slug} />
        </div>
      </section>
      <Faq />
      <Quote />
    </>
  );
}
